import React from 'react'
import useSettingsV2 from '../hooks/useSettingsV2'

function MessageColor({ children }) {
  const { settings } = useSettingsV2()

  return (
    <div
      style={{
        textAlign: 'center',
        fontSize: 22,
        background: settings?.bgPrimaryColor,
        color: settings?.textPrimaryColor,
        padding: '5px 10px',
        marginBottom: 10,
      }}
    >
      {children}
    </div>
  )
}

export default MessageColor
